import React, { useState } from "react";
import Sidebar from "../components/sidebar";
import Navbar from "../components/navbar";
import Table from "../components/table";
import filter from "../imgs/filter.svg";

function Transaction() {
  const [page, setPage] = useState("transaction");
  const [filterDropdown, setFilterDropdown] = useState(false);
  return (
    <div className="flex h-full ">
      <Sidebar page={page} />
      <div className=" w-full ml-[304px]">
        <Navbar page={page} />
        <div className="flex flex-col gap-[39px] px-8 ">
          <div
            className="bg-[#F7F9FD] flex gap-2 border border-[#D7E1F4] w-[190px] p-2 rounded-xl"
            onClick={() => setFilterDropdown(!filterDropdown)}
          >
            <img src={filter} alt="" />
            <p className="text-[16px] text-[#6882B6] leading-[#6882B6]">
              Filter
            </p>
          </div>
          {filterDropdown ? (
            <div className="absolute mt-[40px] border w-[190px] p-3 bg-white rounded-lg">
              <div className=" flex items-center  border-b active:opacity-50 px-2 py-1 hover:shadow-md">
                <p className=" text-[14px] font-medium text-[#EE5D50]">
                  Failed
                </p>
              </div>
              <div className=" flex items-center  border-b px-2 py-1 active:opacity-50 hover:shadow-md">
                <p className=" text-[14px] font-medium text-[#2DAE32]">
                  Successful
                </p>
              </div>
              <div className=" flex items-center  border-b active:opacity-50 px-2 py-1 hover:shadow-md">
                <p className=" text-[14px] font-medium text-[#FFB547]">
                  Initiated
                </p>
              </div>
            </div>
          ) : (
            <></>
          )}
          <div className="w-[915px] flex flex-col">
            <div className="flex w-full gap-[10px] text-[#6882B6] text-[14px] font-medium leading-none tracking-[2%] ">
              <div className=" min-w-[157px]">
                <p>Service</p>
              </div>
              <div className="min-w-[90px]">
                <p>Amount</p>
              </div>
              <div className="min-w-[102px]">
                <p>Total Amount</p>
              </div>
              <div className="min-w-[85px]">
                <p>Status</p>
              </div>
              <div className="min-w-[129px]">
                <p>Payment Method</p>
              </div>
              <div className="min-w-[233px]">
                <p>Transaction No</p>
              </div>
              <div className="min-w-[53px]">
                <p>Actions</p>
              </div>
            </div>
            <div className="mt-6 flex flex-col gap-4">
              <Table
                data={{
                  status: "initiated",
                  amount: "₦100.00",
                  payment: "Transfer",
                  phoneNo: "09068562949",
                  service: "Mtn Airtime VTU",
                }}
              />
              <Table
                data={{
                  status: "successful",
                  amount: "₦2000.00",
                  payment: "Wallet",
                  phoneNo: "07089075584",
                  service: "Airtel DATA VTU",
                }}
              />
              <Table
                data={{
                  status: "failed",
                  amount: "₦4000.00",
                  payment: "Card Payment",
                  phoneNo: 6543654304,
                  service: "Startime",
                }}
              />
              <Table
                data={{
                  status: "initiated",
                  amount: "₦100.00",
                  payment: "Transfer",
                  phoneNo: "4576432833",
                  service: "DSTV",
                }}
              />
              <Table
                data={{
                  status: "successful",
                  amount: "₦2000.00",
                  payment: "Wallet",
                  phoneNo: "07089075584",
                  service: "Airtel Airtime VTU",
                }}
              />
              <Table
                data={{
                  status: "failed",
                  amount: "₦4000.00",
                  payment: "Card Payment",
                  phoneNo: "07089075584",
                  service: "Airtel Airtime VTU",
                }}
              />
              <Table
                data={{
                  status: "initiated",
                  amount: "₦100.00",
                  payment: "Transfer",
                  phoneNo: "07089075584",
                  service: "Airtel Airtime VTU",
                }}
              />
              <Table
                data={{
                  status: "successful",
                  amount: "₦2000.00",
                  payment: "Wallet",
                  phoneNo: "07089075584",
                  service: "Airtel Airtime VTU",
                }}
              />
              <Table
                data={{
                  status: "failed",
                  amount: "₦4000.00",
                  payment: "Card Payment",
                  phoneNo: "07089075584",
                  service: "Airtel Airtime VTU",
                }}
              />
              <Table
                data={{
                  status: "initiated",
                  amount: "₦100.00",
                  payment: "Transfer",
                  phoneNo: "07089075584",
                  service: "Airtel Airtime VTU",
                }}
              />
              <Table
                data={{
                  status: "successful",
                  amount: "₦2000.00",
                  payment: "Wallet",
                  phoneNo: "07089075584",
                  service: "Airtel Airtime VTU",
                }}
              />
              <Table
                data={{
                  status: "failed",
                  amount: "₦4000.00",
                  payment: "Card Payment",
                  phoneNo: "07089075584",
                  service: "Airtel Airtime VTU",
                }}
              />
              <Table
                data={{
                  status: "initiated",
                  amount: "₦100.00",
                  payment: "Transfer",
                  phoneNo: "07089075584",
                  service: "Airtel Airtime VTU",
                }}
              />
              <Table
                data={{
                  status: "successful",
                  amount: "₦2000.00",
                  payment: "Wallet",
                  phoneNo: "07089075584",
                  service: "Airtel Airtime VTU",
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Transaction;
